import React, { useEffect, useState } from "react";
import {
  CreateJobapi,
  Deletejobapi,
  fetchJobapi,
  fetchJobDetailapi,
  UpdateJobapi,
} from "../utility/api";

import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import FullPageLoader from "../Components/loader/FullPageLoader";

function Job() {
  const [joblisting, setjoblisting] = useState([]);
  //console.log("joblisting", joblisting);
  const [isLoading, seLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [detailShow, setDetailShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [modalid, setModalid] = useState("");
  const userId = useSelector((state) => state.auth.userId);

  const [modalData, setModalData] = useState({
    job_title: "",
    department: "",
    job_location: "",
    salary: "",
    workHours: "",
    job_description: [],
    job_responsibilities: [],
    interview_mode: "",
    company_name: "",
    website: "",
  });
  const [modelDetails, setModelDetails] = useState(null);
  const fetchlist = async () => {
    try {
      const data = await fetchJobapi();
      //console.log("data", data);
      if (data?.data?.status === true) {
        setjoblisting(data.data.data);
      } else {
        throw new Error("Failed to fetch job listings.");
      }
    } catch (error) {
      console.error("Error fetching job listings:", error.message);
    } finally {
      seLoading(false);
    }
  };

  useEffect(() => {
    fetchlist();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "job_description" || name === "job_responsibilities") {
      setModalData({
        ...modalData,
        [name]: value,
      });
    } else {
      setModalData({
        ...modalData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async () => {
    seLoading(true);
    const requestData = {
      created_by: userId,
      ...modalData,
      staus: "Open",
    };

    try {
      const response = await CreateJobapi(requestData);
      //console.log("response", response);
      if (response?.data?.status === true) {
        seLoading(false);
        setShow(false);
        fetchlist();
      } else {
        seLoading(false);
        console.error("Failed to create model");
      }
    } catch (error) {
      console.error("Error creating model:", error);
    }
  };

  const handleUpdate = async (id) => {
    seLoading(true);
    const requestData = {
      created_by: userId,
      ...modalData,
    };

    try {
      const response = await UpdateJobapi(id, requestData);

      if (response?.data?.status === true) {
        seLoading(false);
        setDetailShow(false);
        fetchlist();
      } else {
        seLoading(false);
        console.error("Failed to create model");
      }
    } catch (error) {
      console.error("Error creating model:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const data = await Deletejobapi(id);

      if (data?.data?.status === true) {
        //console.log("data", data);
        fetchlist();
      }
    } catch {}
  };

  const handleShowDetails = async (id) => {
    seLoading(true);
    try {
      const response = await fetchJobDetailapi(id);
      //console.log("responsegetdata", response);
      if (response?.data?.status === true) seLoading(false);
      setModelDetails(response.data.data);
      setModalData(response.data.data || {});
      setModalid(response?.data?.data?._id);
      setDetailShow(true);
      setEditMode(false);
    } catch (error) {
      seLoading(false);
      console.error("Error fetching model details:", error);
    }
  };

  const handleStatusToggle = async (id, currentStatus) => {
    //console.log("id", currentStatus);
    const requestData = {
      created_by: userId,

      job_title: id?.job_title,
      department: id?.department,
      job_location: id?.job_location,
      salary: id?.salary,
      workHours: id?.workHours,
      job_description: id?.job_description,
      job_responsibilities: id?.job_responsibilities,
      interview_mode: id?.interview_mode,
      company_name: id?.company_name,
      website: id?.website,
      status: currentStatus === "Open" ? "Closed" : "Open",
    };

    try {
      const response = await UpdateJobapi(id?._id, requestData);
      if (response?.data?.status === true) {
        fetchlist();
      } else {
        seLoading(false);
        console.error("Failed to create model");
      }
    } catch {}
  };

  return (
    <>
      {isLoading ? (
        <FullPageLoader />
      ) : (
        <div className="container-fluid ps-3">
          <div className="d-flex justify-content-end mb-3">
            <button className="btn btn-primary" onClick={() => setShow(true)}>
              Create Job
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col">Job Title</th>
                      <th scope="col">Job Location</th>
                      <th scope="col">Department</th>
                      <th scope="col">Salary</th>
                      <th scope="col">Details</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {joblisting?.map((ele, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>{ele?.job_title}</td>
                        <td>{ele?.job_location}</td>
                        <td>{ele?.salary}</td>
                        <td>{ele?.workHours}</td>
                        <td>
                          <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleShowDetails(ele._id)}
                          >
                            Details
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(ele._id)}
                          >
                            Delete
                          </button>
                        </td>
                        <td>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={ele.status === "Open" ? 1 : 0}
                              onChange={() =>
                                handleStatusToggle(ele, ele?.status)
                              }
                            />
                            <span className="slider round"></span>
                          </label>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Body>
          <h3 className="text-center py-4 position-relative title">
            Create New Blogs
            <span
              className="modalClose"
              onClick={() => {
                setShow(false);
                setModalData({});
              }}
              style={{ cursor: "pointer" }}
            >
              <IoClose />
            </span>
          </h3>

          <div className="p-4">
            <div className="form-group mb-4">
              <label>
                <h6>Job Title</h6>
              </label>
              <input
                type="text"
                name="job_title"
                value={modalData.job_title}
                onChange={handleChange}
                placeholder="Enter job Title"
                className="form-control"
              />
              <label>
                <h6>Department</h6>
              </label>
              <input
                type="text"
                name="department"
                value={modalData.department}
                onChange={handleChange}
                placeholder="Enter Department"
                className="form-control"
              />
              <label>
                <h6>Job Location</h6>
              </label>
              <input
                type="text"
                name="job_location"
                value={modalData.job_location}
                onChange={handleChange}
                placeholder="Enter Job Location"
                className="form-control"
              />

              <label>
                <h6>Salary</h6>
              </label>
              <input
                type="text"
                name="salary"
                value={modalData.salary}
                onChange={handleChange}
                placeholder="Enter Salary"
                className="form-control"
              />
              <label>
                <h6>Working Hours</h6>
              </label>
              <input
                type="text"
                name="workHours"
                value={modalData.workHours}
                onChange={handleChange}
                placeholder="Enter Work Hours"
                className="form-control"
              />
              <label>
                <h6>Job Description</h6>
              </label>

              <textarea
                name="job_description"
                value={modalData.job_description}
                onChange={handleChange}
                placeholder="Enter Job Description"
                className="form-control"
                rows={4}
                cols="8"
              ></textarea>
              <label>
                <h6>Job Responsiblities </h6>
              </label>

              <textarea
                name="job_responsibilities"
                value={modalData.job_responsibilities}
                onChange={handleChange}
                placeholder="Enter Job Responsibilities"
                className="form-control"
                rows={4}
                cols="8"
              ></textarea>
              <label>
                <h6>Interview Mode</h6>
              </label>
              <input
                type="text"
                name="interview_mode"
                value={modalData.interview_mode}
                onChange={handleChange}
                placeholder="Enter Interview Mode"
                className="form-control"
              />
              <label>
                <h6>Company Name</h6>
              </label>
              <input
                type="text"
                name="company_name"
                value={modalData.company_name}
                onChange={handleChange}
                placeholder="Enter Company Name"
                className="form-control"
              />
              <label>
                <h6>website</h6>
              </label>
              <input
                type="text"
                name="website"
                value={modalData.website}
                onChange={handleChange}
                placeholder="Enter Website"
                className="form-control"
              />
            </div>
            <div className="text-center">
              <button className="btn btn-primary" onClick={handleSubmit}>
                Save
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Model Details Modal */}
      <Modal show={detailShow} onHide={() => setDetailShow(false)}>
        <Modal.Body>
          <h3 className="text-center py-4 position-relative title">
            Blog Details
            <span
              className="modalClose"
              onClick={() => {
                setDetailShow(false);
                setModalData({});
              }}
              style={{ cursor: "pointer" }}
            >
              <IoClose />
            </span>
          </h3>

          <div className="p-4">
            <div className="form-group mb-4">
              <label>
                <h6>Title</h6>
              </label>
              <input
                type="text"
                name="job_title"
                value={modalData.job_title}
                onChange={handleChange}
                placeholder="Enter job Title"
                className="form-control"
              />
              <label>
                <h6>Department</h6>
              </label>
              <input
                type="text"
                name="department"
                value={modalData.department}
                onChange={handleChange}
                placeholder="Enter Department"
                className="form-control"
              />
              <label>
                <h6>Job Location</h6>
              </label>
              <input
                type="text"
                name="job_location"
                value={modalData.job_location}
                onChange={handleChange}
                placeholder="Enter Job Location"
                className="form-control"
              />

              <label>
                <h6>Salary</h6>
              </label>
              <input
                type="text"
                name="salary"
                value={modalData.salary}
                onChange={handleChange}
                placeholder="Enter Salary"
                className="form-control"
              />

              <label>
                <h6>Working Hours</h6>
              </label>
              <input
                type="text"
                name="workHours"
                value={modalData.workHours}
                onChange={handleChange}
                placeholder="Enter Work Hours"
                className="form-control"
              />
              <label>
                <h6>Job Description</h6>
              </label>

              <textarea
                name="job_description"
                value={modalData.job_description}
                onChange={handleChange}
                placeholder="Enter Job Description"
                className="form-control"
                rows={4}
                cols="8"
              ></textarea>
              <label>
                <h6>Job Responsiblities </h6>
              </label>

              <textarea
                name="job_responsibilities"
                value={modalData.job_responsibilities}
                onChange={handleChange}
                placeholder="Enter Job Responsibilities"
                className="form-control"
                rows={4}
                cols="8"
              ></textarea>
              <label>
                <h6>Interview Mode</h6>
              </label>
              <input
                type="text"
                name="interview_mode"
                value={modalData.interview_mode}
                onChange={handleChange}
                placeholder="EnterInterview Mode"
                className="form-control"
              />
              <label>
                <h6>Company Name</h6>
              </label>
              <input
                type="text"
                name="company_name"
                value={modalData.company_name}
                onChange={handleChange}
                placeholder="Enter Company Name"
                className="form-control"
              />
              <label>
                <h6>website</h6>
              </label>
              <input
                type="text"
                name="website"
                value={modalData.website}
                onChange={handleChange}
                placeholder="Enter Website"
                className="form-control"
              />
            </div>
            <div className="text-center">
              {editMode ? (
                <>
                  <button
                    className="btn btn-success me-2"
                    onClick={() => handleUpdate(modalid)}
                  >
                    Update
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setEditMode(false)}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  className="btn btn-primary"
                  onClick={() => setEditMode(true)}
                >
                  Edit
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Job;
